import { render, staticRenderFns } from "./NextRoute.vue?vue&type=template&id=f27a96a8&scoped=true&"
import script from "./NextRoute.vue?vue&type=script&lang=js&"
export * from "./NextRoute.vue?vue&type=script&lang=js&"
import style0 from "./NextRoute.vue?vue&type=style&index=0&id=f27a96a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27a96a8",
  null
  
)

export default component.exports